import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_DEFAULT_TIMEZONE } from './common/constants/date-config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { ServerErrorInterceptor } from './interceptors/server-error-interceptor';
import { DateModule } from './date.module';
import * as moment from 'moment-timezone';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

moment.tz.setDefault(APP_DEFAULT_TIMEZONE);

const SHARED_MODULES = [CommonModule, BrowserAnimationsModule, HttpClientModule, MaterialModule, DateModule];

@NgModule({
  declarations: [],
  imports: [...SHARED_MODULES],
  exports: [...SHARED_MODULES],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        hideRequiredMarker: true,
      },
    },
  ],
})
export class IntrackCoreModule {}
